//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  includeExpired: false,
  additionalFilters: "notSet",
  sortBy: 'dateCreated',
  queryKey: ['framework-agreements'],
  queryOptions: {},
};

const getAllFrameworkAgreements = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const { data } = await axios.get(`/api/framework_agreements?${queryString}`);

  return data;
};

export const useFrameworkAgreements = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, search, includeInactive, includeExpired, additionalFilters, sortBy } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: includeExpired,
    additionalfilters: additionalFilters,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery([...queryKey], () => getAllFrameworkAgreements(queryStringParams), {
    select: ({ data: frameworkAgreements, total }) => ({ frameworkAgreements, total }),
    initialData: {
      frameworkAgreements: [],
      total: 0,
    },
    ...queryOptions,
  });
};
